interface IGalleryItemProps {
    index: number,
    slideItemWidth: number, // for horizontal gallery
    slideItemHeight?: number, // for vertical gallery
    gap: number,
    left: number, // for horizontal gallery
    top?: number, // for vertical gallery
    renderItem: Function,
    item: any,
    isVertical?: boolean,
}

const GalleryItem = (props: IGalleryItemProps) => {
    return (
        <div
            key={ `animated-loop-item-${ props.index }` }
            data-index={ props.index }
            data-current={ props.index }
            style={{
                width: props.isVertical ? 'auto' : `${ props.slideItemWidth }px`,
                height: props.isVertical ? `${ props.slideItemHeight }px` : 'auto',
                marginRight: props.isVertical ? 'auto' : `${ props.gap }px`,
                marginBottom: props.isVertical ? `${ props.gap }px` : 'auto',
                position: 'absolute',
                top: props.isVertical ? `${ props.top }px` : 0,
                left: props.isVertical ? 0 : `${ props.left }px`,
                perspective: '1000px',
                backfaceVisibility: 'hidden',
            }}>
            { props.item && props.renderItem(props.item, props.slideItemWidth) }
        </div>
    )
};

export default GalleryItem;